import React, { useState, useCallback, useEffect } from 'react';
import { Input, Avatar, Icon, AutoComplete, message, Tooltip } from 'antd';
import styles from './selectOrder.module.scss';
import debounce from 'lodash/debounce';
import * as apis from '@/apis';

function renderOption(item, idx) {
  return (
    <AutoComplete.Option key={item._id}>
      <span> {item.order_no}</span>
    </AutoComplete.Option>
  );
}

function renderEmpty() {
  const emptyInfo = (
    <AutoComplete.Option key="disabled" disabled>
      <span>无匹配项</span>
    </AutoComplete.Option>
  );
  return [emptyInfo];
}

export default function SelecOrder({
  onChange,
  placeholder,
  value: initialValue = null,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState();
  const [list, setList] = useState([]);
  const handleSearch = useCallback(
    debounce(async (value) => {
      setFetching(true);
      try {
        const result = await apis.searchOrder(value);
        setFetching(false);
        setList(result.data);
      } catch (error) {
        setFetching(false);
        message.info(error.message || '接口异常');
      }
    }, 800),
    []
  );
  const resetValue = useCallback(() => {
    setData(null);
    onChange && onChange(null);
  }, []);
  const onSelect = useCallback(
    (value) => {
      const data = list.find((item) => item._id === value);
      setData(data);
      onChange && onChange(data._id);
    },
    [list]
  );
  const init = useCallback(async () => {
    console.log('initialValue && !user:', initialValue, data);
    if (initialValue && !data) {
      try {
        const result = await apis.getOrderById(initialValue);
        result && setData(result);
      } catch (error) {}
    }
  }, [initialValue, data]);

  useEffect(() => {
    init();
  }, []);

  if (data) {
    return (
      <Input
        addonAfter={
          <Tooltip title="解除">
            <Icon type="close-circle" onClick={resetValue} />
          </Tooltip>
        }
        disabled
        value={data.order_no}
        style={props.style || {}}
      />
    );
  }

  return (
    <div style={props.style || {}}>
      <AutoComplete
        dataSource={list.length ? list.map(renderOption) : renderEmpty()}
        onSearch={handleSearch}
        onSelect={onSelect}
      >
        <Input.Search placeholder={placeholder} loading={fetching} />
      </AutoComplete>
    </div>
  );
}
